import React, { useState, useEffect } from "react";
import AzureCredentialsForm from "@/components/forms/AzureCredentialsForm";
import ApacheCredentialForm from "@/components/forms/ApacheCredentialForm";
import { LinesStackSkeleton } from "@/components/skeletons";
import { DIRECTORY_SERVICES_LIST } from "@/utils/constants/appConstants/DirectoryConstants";
import { HEADINGS } from "@/utils/constants/appConstants/commonConstants";

type LDAPType = "azure" | "apache";

const DISPLAY_NAME_MAPPING: Record<LDAPType, string> = {
    azure: "Microsoft Entra Id",
    apache: "Apache",
};

const DirectoryService = () => {
    const [selectedOption, setSelectedOption] = useState<LDAPType | "">("");
    const [loadConnectorData] = useState(false);

    useEffect(() => {
        if (DIRECTORY_SERVICES_LIST.length > 0) {
            setSelectedOption(DIRECTORY_SERVICES_LIST[0].toLowerCase() as LDAPType);
        }
    }, []);

    const LDAPTypeComponents: Record<LDAPType, JSX.Element> = {
        azure: <AzureCredentialsForm />,
        apache: <ApacheCredentialForm />,
    };

    return (
        <div className="gs-directory-page">
            <h3 className="gs-directory-page__title" id="role-detail-title">
                {HEADINGS.DIRECTORY_SERVICES}
            </h3>
            {loadConnectorData ? (
                <LinesStackSkeleton rowCount={3} className="gs-directory-card gs-directory-card__section" />
            ) : (
                <>
                    <ul className="gs-page-tabs gs-directory-page__tabs">
                        {DIRECTORY_SERVICES_LIST.map((service, index) => (
                            <li key={index}>
                                <button
                                    type="button"
                                    className={`gs-page-tab${selectedOption === service.toLowerCase() ? " gs-page-tab--active" : ""}`}
                                    id={`directory-tab-${index}`}
                                    onClick={() => setSelectedOption(service.toLowerCase() as LDAPType)}
                                >
                                    {DISPLAY_NAME_MAPPING[service.toLowerCase() as LDAPType]}
                                </button>
                            </li>
                        ))}
                    </ul>
                    <div className="gs-directory-page__panel">
                        {selectedOption && LDAPTypeComponents[selectedOption as LDAPType]}
                    </div>
                </>
            )}
        </div>
    );
};

export default DirectoryService;
